import {
  LOGIN_SUCCESS,
  USER_LOGOUT,
} from "../constant/user";

const initialState = {
  userInfo: {
    authToken: ""
  },
};

const userDetailsReducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        userInfo: action.payload,
      };
    case USER_LOGOUT:
      return {
        ...state,
        userInfo: "",
      };
    default:
      return state;
  }
};

export default userDetailsReducer;